import request from '@/utils/request'

// 获取管理员列表
export function getList(params) {
  return request({
    url: '/admin/index',
    method: 'get',
    params
  })
}

// 获取管理员的权限
export function getAdminRule(params) {
  return request({
    url: '/admin/admin_rule',
    method: 'get',
    params
  })
}

export function getDetail(id) {
  return request({
    url: `/admin/detail/${id}`,
    method: 'get'
  })
}

export function getRules(id) {
  return request({
    url: `/admin/${id}/rules`,
    method: 'get'
  })
}

export function getGroups() {
  return request({
    url: '/auth_group/tree',
    method: 'get'
  })
}

export function createAdmin(data) {
  return request({
    url: '/admin/create',
    method: 'post',
    data
  })
}

export function updateAdmin(id, data) {
  return request({
    url: `/admin/edit/${id}`,
    method: 'put',
    data
  })
}

export function deleteAdmin(id) {
  return request({
    url: `/admin/del/${id}`,
    method: 'delete'
  })
}

export function enableAdmin(id) {
  return request({
    url: `/admin/${id}/enable`,
    method: 'patch'
  })
}

export function disableAdmin(id) {
  return request({
    url: `/admin/${id}/disable`,
    method: 'patch'
  })
}

// 修改管理员密码
export function updatePassword(data) {
  return request({
    url: `/admin/set_password`,
    method: 'post',
    data
  })
}
// 设置分组
export function updateAccess(data) {
  return request({
    url: `/admin/set_group`,
    method: 'post',
    data
  })
}

export function logoutAdmin(refreshToken) {
  return request({
    url: `/admin/logout/${refreshToken}`,
    method: 'delete'
  })
}

export function getBalance(uid) {
  return request({
    url: `/user/quotas/${uid}`,
    method: 'get'
  })
}

export function setBalance(data) {
  return request({
    url: `/user/quotas`,
    method: 'post',
    data
  })
}

export function settingVip(data) {
  return request({
    url: `/admin/set_vip_queue`,
    method: 'put',
    data
  })
}
export function fpAdminList(params) {
  return request({
    url: `/admin/fp_admin_list`,
    method: 'get',
    params
  })
}
export function bindFpAdmin(params) {
  return request({
    url: `/admin/bind_fp_admin`,
    method: 'put',
    params
  })
}
